import React from 'react'
import { Grid, Typography } from '@material-ui/core/'
import infoIcon from '../../../../../../../assetss/img/infoIcon.svg'
import './index.scss'

const DateMeeting = ({ date, time, name, newTitle, noAvtor, isMobile }) => {
  return (
    <Grid className='newWrapperDateTimeContainer'>
      <Grid className='dateTimeContainer'>
        <img className='infoIcon' src={infoIcon} />
        <Grid className='dateTimeBox'>
          <Typography className='avtorNameMeet'>
            {noAvtor ? (
              newTitle ? isMobile ? `${name} suggested the following date and time. Please confirm or decline date and time  by clicking on Meeting details button.` : `${name} suggested the following date and time. Please confirm or decline date and time in the form on the right side of the screen.` : `Your meeting request has beeen sent to ${name}. Please wait for the request to be accepted.`
            ) : (
              newTitle ? `${name} suggested meeting time:` : `Your meeting request has beeen sent to ${name}. Please wait for the request to be accepted.`
            )}
          </Typography>
          <Typography className='date'><span>Date:</span> {date}</Typography>
          <Typography className='time'><span>Time*:</span> {time}</Typography>
          <Typography className='descText'>*Note that the time is automatically synchronized with the receiver's time zone.</Typography>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default DateMeeting
